import React from 'react';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {getLabel} from '../../../../../@casino/lib/getLabel';
import {useStyles} from './helpers';

const BreadCrumbs = (label) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapBreadCrumbs}>
            <span className={classes.breadCrumbs}>
                Бонусы
            </span>
            <ArrowRight className={classes.arrowBreadCrumbs}/>
            <span className={classes.breadCrumbs}>
                Настройка
            </span>
            <ArrowRight className={classes.arrowBreadCrumbs}/>
            <span className={classes.breadCrumbs}>
                {getLabel(label.label)}
            </span>
        </div>
    )
}

export default BreadCrumbs